import { MarkerType } from "reactflow";
import {
  GOVERNANCE_EDGE_STYLE,
  MANAGEMENT_EDGE_STYLE,
  CROSS_LAYER_EDGE_STYLE,
  COLORS,
} from "../Styles/nodeStyles";

export const initialEdges = [
  // Data Governance connections
  {
    id: "e-gs-bg",
    source: "governeye-setup",
    target: "business-goals",
    type: "smoothstep",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-gs-dga",
    source: "governeye-setup",
    target: "dg-assessment",
    type: "smoothstep",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-bg-ds",
    source: "business-goals",
    target: "data-strategy",
    targetHandle: "left-target-1",
    type: "smoothstep",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-dga-ds",
    source: "dg-assessment",
    target: "data-strategy",
    targetHandle: "left-target-2",
    type: "smoothstep",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-ds-ucb",
    source: "data-strategy",
    target: "use-case-book",
    type: "straight",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-ucb-ucp",
    source: "use-case-book",
    target: "uc-prioritized",
    targetHandle: "left-target",
    type: "straight",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-ucp-dc",
    source: "uc-prioritized",
    target: "data-catalog",
    targetHandle: "left-target",
    type: "straight",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-dc-dq",
    source: "data-catalog",
    target: "data-quality",
    targetHandle: "left-target",
    type: "straight",
    animated: true,
    style: GOVERNANCE_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.ORANGE,
      width: 20,
      height: 20,
    },
  },

  // Data Management connections
  {
    id: "e-ss-eda",
    source: "skeye-setup",
    sourceHandle: "right",
    target: "eda",
    targetHandle: "left-target",
    type: "straight",
    animated: true,
    style: MANAGEMENT_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.NAVY,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-eda-impl",
    source: "eda",
    sourceHandle: "right",
    target: "implementation",
    targetHandle: "left",
    type: "straight",
    animated: true,
    style: MANAGEMENT_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.NAVY,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-impl-dash",
    source: "implementation",
    target: "dashboarding",
    type: "smoothstep",
    animated: true,
    style: MANAGEMENT_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.NAVY,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-impl-pred",
    source: "implementation",
    target: "predictive-analytics",
    type: "smoothstep",
    animated: true,
    style: MANAGEMENT_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.NAVY,
      width: 20,
      height: 20,
    },
  },

  // Cross-layer connections (vertical)
  {
    id: "e-ds-ss",
    source: "data-strategy",
    sourceHandle: "bottom",
    target: "skeye-setup",
    targetHandle: "top-target",
    type: "straight",
    animated: false,
    style: CROSS_LAYER_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.GREY,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-ucp-eda",
    source: "uc-prioritized",
    sourceHandle: "bottom",
    target: "eda",
    targetHandle: "top-target-left",
    type: "straight",
    animated: false,
    style: CROSS_LAYER_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.GREY,
      width: 20,
      height: 20,
    },
  },
  {
    id: "e-eda-dc",
    source: "eda",
    sourceHandle: "top-source-right",
    target: "data-catalog",
    targetHandle: "bottom-target-1",
    type: "smoothstep",
    animated: false,
    style: CROSS_LAYER_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.GREY,
      width: 15,
      height: 15,
    },
  },
  {
    id: "e-impl-group-dc",
    source: "implementation-group",
    sourceHandle: "top",
    target: "data-catalog",
    targetHandle: "bottom-target-2",
    type: "smoothstep",
    animated: false,
    style: CROSS_LAYER_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.GREY,
      width: 15,
      height: 15,
    },
  },
  {
    id: "e-dq-impl-group",
    source: "data-quality",
    sourceHandle: "bottom",
    target: "implementation-group",
    targetHandle: "top-target",
    type: "smoothstep",
    animated: false,
    style: CROSS_LAYER_EDGE_STYLE,
    markerEnd: {
      type: MarkerType.ArrowClosed,
      color: COLORS.GREY,
      width: 20,
      height: 20,
    },
  },
];
